import { render, staticRenderFns } from "./NewClient.vue?vue&type=template&id=cfe4be6e&scoped=true&"
import script from "./NewClient.vue?vue&type=script&lang=js&"
export * from "./NewClient.vue?vue&type=script&lang=js&"
import style0 from "./NewClient.vue?vue&type=style&index=0&id=cfe4be6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe4be6e",
  null
  
)

export default component.exports